module.exports = __webpack_public_path__ + "static/media/404.08f15082.svg";